import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class AGAuslandBeschaftigung extends AdornisEntity {
  static override _class = 'AGAuslandBeschaftigung';

  static override resolveID(entity: any): string {
    entity._id = entity._id ?? A.getGloballyUniqueID();
    return entity._id;
  }

  @Field(() => ID, { default: v => v ?? A.getGloballyUniqueID() }) _id!: string;

  @Field(() => Date)
  beschaftigungsBeginn: Maybe<Date>;

  @Field(() => Date)
  beschaftigungsEnde: Maybe<Date>;

  @Field(() => String)
  arbeitgeberMitAdresse: Maybe<string>;
}
